import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';

class PatientCareCenterAlWorkProgram extends React.Component {

    render() {
        if (this.props.all.length === 0) {
            return (<span />);
        }
        return (
            <div className={styles.body}>

                <div className={styles.section_row}>
                    <span className={styles.col1_bold_italic}>
                        {'Work Program'}
                    </span>
                    {Object.keys(this.props.MLEXLOG)
                        .map(x => {
                            const exlog = this.props.MLEXLOG[x];
                            return (
                                <span key={exlog.XLNO} className={styles.col_bold_italic}>
                                    {exlog.XLTIMEWORKPROG ? exlog.XLTIMEWORKPROG + ' min.' : ''}
                                </span>
                            )
                        })
                    }
                </div>

                {Object.keys(this.props.all)
                    .map(x => {
                        const row = this.props.all[x];
                        return (
                            <div key={row[0]} id={row[0]} className={styles.row} >
                                <span className={styles.col1_bold}>
                                    {row[0]}
                                </span>
                                {Object.keys(row)
                                    .filter(x => x > 0)
                                    .map(y => {
                                        const col = row[y];
                                        return (
                                            <span key={x + '_' + y} id={x + '_' + y} className={styles.col}>
                                                {col}
                                            </span>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }

            </div>
        );
    }
}

function appendActivity(all, activity, index, visitCount) {
    let found = false;
    let val = activity.XLWPSETSREPS;

    Object.keys(all)
        .forEach(x => {
            if (all[x][0] === activity.XLWPACTIVITY) {
                all[x][index + 1] = val;
                found = true;
            }
        });

    if (!found) {
        let row = new Array(visitCount + 1);
        row.fill('');
        row[0] = activity.XLWPACTIVITY;
        row[index + 1] = val;
        all.push(row);
    }

}

function mapStateToProps(state, ownprops) {
    let displayMode = state.ui.al[ownprops.epno].displayMode;
    let MLEXLOG = Object.keys(state.entities.al.MLEXLOG)
        .filter(x => state.entities.al.MLEXLOG[x].EPNO === ownprops.epno)
        .sort((a, b) => new Date(state.entities.al.MLEXLOG[a].TRTDATE).getTime() - new Date(state.entities.al.MLEXLOG[b].TRTDATE).getTime())
        .map(x => state.entities.al.MLEXLOG[x]);

    MLEXLOG = displayMode === -1 || MLEXLOG.length <= displayMode ? MLEXLOG : MLEXLOG.slice(MLEXLOG.length - displayMode, MLEXLOG.length);
    let index = 0;

    let all = [];
    let visitCount = MLEXLOG.length;

    Object.keys(MLEXLOG)
        .forEach(x => {

            Object.keys(state.entities.al.MLWORKPROG)
                .filter(y => state.entities.al.MLWORKPROG[y].XLWPXLNO === MLEXLOG[x].XLNO)
                .sort((a, b) => state.entities.al.MLWORKPROG[a].XLWPNO - state.entities.al.MLWORKPROG[b].XLWPNO)
                .forEach(z => {
                    appendActivity(all, state.entities.al.MLWORKPROG[z], index, visitCount);
                });
            index++;
        });



    return {
        MLEXLOG,
        all,
        visitCount
    };
}

const connectedPatientCareCenterAlWorkProgram = connect(mapStateToProps)(PatientCareCenterAlWorkProgram);
export { connectedPatientCareCenterAlWorkProgram as PatientCareCenterAlWorkProgram };

